import { render, staticRenderFns } from "./patfromShare.vue?vue&type=template&id=14cc105a&scoped=true&"
import script from "./patfromShare.vue?vue&type=script&lang=js&"
export * from "./patfromShare.vue?vue&type=script&lang=js&"
import style0 from "./patfromShare.vue?vue&type=style&index=0&id=14cc105a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cc105a",
  null
  
)

export default component.exports